import { Deserializable } from '../../protocols/deserializable';

export class EmployeeTableUserLastContributionDetails implements Deserializable {
  public designatedUnitId!: number | null;
  public designatedUnitName!: string | null;
  public annualSalary!: number | null;
  public lastProcessedContributionDate!: string | null;

  public onDeserialize() {}
}
